import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Row, Col, Tag, Alert } from 'antd'
import { isMobile } from 'react-device-detect';
import { isValidDate, getActionColor } from '@/utils/helpers';
import AuditLogDiffTable from '@/routes/audit-logs/AuditLogDiffTable';

class AuditLogDetail extends Component {
    constructor() {
        super();
        this.state = {
        };
    }

    handleCancel() {
        this.props.onCancel();
    }


    render() {
        var { visible, currentItem } = this.props;

        return (
            <>
                <Drawer
                    visible={visible}
                    title={`Chi tiết thay đổi: ${currentItem?.model} - #${currentItem?.id}`}
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '75%'}
                >
                    {visible ? (
                        <>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Module">
                                            {currentItem ? currentItem.module : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Model">
                                            {currentItem ? currentItem.model : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Người thực hiện">
                                            {currentItem ? currentItem.user?.full_name : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Hành động">
                                            <Tag color={getActionColor(currentItem?.action)}>{currentItem?.action.toUpperCase()}</Tag>
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Thời gian">
                                            {isValidDate(currentItem.created_at, true)}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Địa chỉ IP">
                                            {currentItem?.ip_address}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="User agent">
                                            {currentItem?.user_agent}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Request uri">
                                            {currentItem?.request_uri}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Method">
                                            {currentItem?.method}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Trường thay đổi">
                                            {currentItem?.changed_fields?.join(', ') || 'Không có'}{'\n\n'}
                                        </Descriptions.Item>
                                    </Descriptions>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    {currentItem?.rolled_back_by && (
                                        <Alert
                                            message={`Bản ghi này đã được rollback bởi ${currentItem.rolled_back_by?.user?.full_name || '---'} vào lúc ${isValidDate(currentItem?.rolled_back_by.created_at, true)}`}
                                            type="warning"
                                            showIcon
                                            className='mt-2 mb-2'
                                        />
                                    )}

                                    {currentItem?.rollback_origin && (
                                        <Alert
                                            message={`Đây là bản ghi rollback từ log #${currentItem.rollback_of_log_id}`}
                                            type="warning"
                                            showIcon
                                            className='mt-2 mb-2'
                                        />
                                    )}
                                </Col>
                            </Row>
                            <h5 style={{ marginTop: 20 }}>So sánh thay đổi</h5>
                            <AuditLogDiffTable before={currentItem?.before} after={currentItem?.after} />
                        </>
                    ) : null}
                </Drawer>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'AuditLogDetail' })(AuditLogDetail));
